import React from "react";
import { IconProps } from "../icon";

export const CurrencyRubleIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8.5 11.5h6a4 4 0 000-8h-6v8zm0 0h-2m7 4h-7M8.5 4v16.5"
    />
  </svg>
);
